<template>
  <div class="Info">
    <h1 style="font-size: 150%;">Anmerkung zur Berechnung</h1>
    <v-divider></v-divider>
    <p>
      Die
      <strong>Häufigkeit der augenscheinlichen Inspektionen</strong> sollte auf den Schweregrad von spezifischen Parametern bezogen werden, dazu gehören die Anzahl der Biegewechsel, die Anzahl der Überrollungen, die Ausprägung des Höhenprofils, die Montagebedingungen, die Umgebungsbedingungen der Anlage und die Personalsituation vor Ort.
    </p>
    <br>
    <p>Die nachfolgende Berechnung listet den relativen Einfluss unterschiedlicher Parameter auf, indem jeweils relative Bewertungen zugeordnet werden.</p>
    <v-divider></v-divider>
    <v-btn @click="accepted" class="INFO" color="blue" style="color: white;">Weiter</v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    accepted() {
      this.$router.push("Inspection");
    }
  }
};
</script>

<style>
.Info {
  background-color: white;
  width: 70%;
  margin: 10% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
  text-align: center;
  font-size: 150%;
  opacity: 0.85;
  filter: alpha(opacity=85);
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .Info {
        font-size: 80%;
    }
}

.INFO{
  color: white;
  font-size: 110%;
}
</style>
